module.exports = __webpack_public_path__ + "img/H-B-6-unload-standup-shadow.30a100fc.png";